module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [_c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "spacing-30 pure-u-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-sm-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-3-5 pure-u-lg-1-2"
  }, [_c('h3', {
    staticClass: "margin-bottom-10 responsive"
  }, [_vm._v(" Login to your Tavour account! ")]), _vm._v(" "), _c('div', {
    staticClass: "subtext margin-left-10"
  }, [_vm._v("\n            New to Tavour? "), _c('a', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.$emit('register')
      }
    }
  }, [_vm._v("create a new account")])]), _vm._v(" "), (_vm.showSso) ? _c('div', {
    staticClass: "spacing-20"
  }) : _vm._e(), _vm._v(" "), (_vm.showSso) ? _c('SsoButtons') : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "pure-u-1 pure-form pure-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "spacing-20"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "pure-input-1",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "pure-input-1",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "pure-button pure-button-primary block",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled
    }
  }, [_vm._v("Login")]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v("\n              " + _vm._s(_vm.error) + "\n            ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacing-30 pure-u-1"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6957b2e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/start/Login.vue
// module id = 394
// module chunks = 1